<div class="country-based" id="mobile-collapse">
  @if (menuState() === 'collapsed') {
    <ul class="nav pcoded-inner-navbar global-ul">
      <li>
        <a class="nav-link center-items">
          @if ((flagCode | async) === 'GLOBE') {
            <span class="pcoded-micon">
              <i class="icon globe-icon"></i>
            </span>
          } @else {
            <span class="flag-circle">
              <img class="flag-code" [src]="(flagCode | async) | flag" alt="Country flag" />
            </span>
          }
        </a>
      </li>
    </ul>
  }
  @else {
    <img [src]="bannerUrl" alt="banner">
  }
</div>

<div class="sidebar-wrapper">
  <div class="sidebar-inner">
    <ng-scrollbar class="menu-scroll">
      <div class="navbar-content">
        <ul class="nav pcoded-inner-navbar">
          @for (item of modules(); track item) {
            <li [class.active]="isActive(item)" (click)="onMenuClick(item)">
              <a class="nav-link" [ngClass]="menuState() === 'collapsed' ? 'center-items' : ''">
                <div class="pcoded-micon"><i class="icon {{ item.moduleIcon }}"></i></div>
                @if (menuState() !== 'collapsed') {
                <div class="pcoded-mtext">{{ item.moduleName | translate }}</div>
                }
              </a>
            </li>
          }
        </ul>
      </div>
    </ng-scrollbar>
    @if (menuState() !== 'collapsed') {
      <div class="app-version">
        <p>QubeBiz+ {{currentYear}}</p>
        <p class="ms-1">Ver {{version}}</p>
      </div>
    }
  </div>
</div> 